import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import personAddOutline from '@iconify/icons-eva/person-add-outline';
import fileFill from '@iconify/icons-eva/file-text-outline';
import autoSchedule from '@iconify/icons-material-symbols/auto-schedule';
import checkbookRounded from '@iconify/icons-material-symbols/checkbook-rounded';
// Add other icon imports...

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const getNavConfig = (account, hasCompany, hasDocuments, hasTraining) => {
  const {
    role
  } = account || {};

  const baseItems = [
    {
      title: 'Dashboard',
      icon: getIcon('mdi:home'),
      children: [
        {
          title: 'Time Records',
          path: '/stores/admin',
        },
        {
          title: 'Activity Logs',
          path: '/stores/admin-activity-logs'
        }
      ]
    },
    {
      title: 'User Management',
      icon: getIcon(personAddOutline),
      children: [
        {
          title: 'Users',
          path: '/stores/user',
        },
        {
          title: 'Archived Users',
          path: '/stores/archive',
        },
      ]
    },
    {
      title: 'Time Management',
      icon: getIcon('mdi:clock-outline'),
      children: [
        {
          title: 'Time Adjustment',
          path: '/stores/adjustment',
        },
        {
          title: 'Schedules',
          path: '/stores/schedule',
        },
        {
          title: 'Breaklist Summary',
          path: '/stores/breaklist-info',
        },
        {
          title: 'Edit Breaklist',
          path: '/stores/manage-breaklist',
        },
        {
          title: 'Generated Breaklist',
          path: '/stores/breaklist',
        },
      ]
    },
    {
      title: 'Access & Authentication',
      icon: getIcon('mdi:qrcode'),
      children: [
        {
          title: 'Registration',
          path: '/stores/qr',
        },
        ...((role === 4)
          ? [{
          title: 'store approval',
          path: '/stores/approval'
          }]
          : []),
        {
          title: 'Biometrics',
          path: '/stores/biometric',
        },
      ]
    },
    {
      title: 'Communication',
      icon: getIcon('mingcute:announcement-line'),
      children: [
        {
          title: 'Broadcast',
          path: '/stores/announcements',
        },
        {
          title: 'Reports',
          path: '/stores/reports',
        },
      ]
    },
    ...(((hasCompany || hasDocuments || hasTraining) && (role === 1)) || role > 1 ? [
    {
      title: 'Company Tools',
      icon: getIcon('mdi:briefcase'),
      children: [
        ...((hasCompany && role === 1 ) || role > 1
          ? [{
              title: 'my company',
              path: '/stores/admin-company',
            }]
          : []),
        ...((hasDocuments && role === 1) || role > 1
          ? [{
              title: 'Required Documents',
              path: '/stores/required-documents',
            }]
          : []),
        ...((hasTraining && role === 1) || role > 1
          ? [{
              title: 'training and development',
              path: '/stores/training-development',
            }]
          : []),
        ...((role >= 3)
          ? [{
              title: 'dice game',
              path: '/stores/dice-game',
            }]
          : []),
        ...((role >= 3)
          ? [{
            title: 'holidays',
            path: '/stores/holidays',
          }]
          : []),
      ]
    },
    ] : []),
  ];

  if (role === 4) {
    baseItems.push(
      {
        title: 'Executive Tools',
        icon: getIcon('mdi:company'),
        children: [
          {
            title: 'features',
            path: '/stores/features',
          },
          {
            title: 'store approval',
            path: '/stores/approval',
          },
          {
            title: 'feedbacks',
            path: '/stores/feedbacks',
          },
        ]
      },
    );
  }

  return baseItems;
};

export default getNavConfig;
